"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;
var _react = require("react");
var _react2 = _interopRequireDefault(_react);
var _Icon2 = require("../../../Icon");
var _Icon3 = _interopRequireDefault(_Icon2);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }
  return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
var IconCheckBadge = /*#__PURE__*/
function (_Icon) {
  _inherits(IconCheckBadge, _Icon);
  function IconCheckBadge(props) {
    var _this;
    _classCallCheck(this, IconCheckBadge);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(IconCheckBadge).call(this, props));
    _this.name = 'IconCheckBadge';
    _this.icon = _react2.default.createElement("svg", {
      viewBox: "0 0 24 24",
      width: "1em",
      height: "1em",
      focusable: "false",
      "aria-hidden": "true",
      role: "presentation"
    }, _react2.default.createElement("g", {
      className: "check-badge_svg__group0"
    }, _react2.default.createElement("path", {
      className: "check-badge_svg__path0",
      d: "M11.317 15.732a1.26 1.26 0 01-.894-.37l-2.442-2.443a.5.5 0 11.708-.706l2.442 2.443a.266.266 0 00.401-.03l4.07-5.426a.503.503 0 01.7-.1.5.5 0 01.1.7l-4.07 5.426a1.275 1.275 0 01-1.015.506z"
    }), _react2.default.createElement("path", {
      className: "check-badge_svg__path1",
      d: "M12 24.001a2.169 2.169 0 01-1.689-.812l-1.542-1.921a1.16 1.16 0 00-1.036-.429l-2.451.267a2.162 2.162 0 01-2.388-2.388l.267-2.452a1.16 1.16 0 00-.429-1.034L.811 13.69a2.169 2.169 0 010-3.38l1.922-1.544c.312-.25.473-.637.429-1.035L2.895 5.28a2.153 2.153 0 01.465-1.592 2.153 2.153 0 011.921-.796l2.453.267a1.159 1.159 0 001.035-.428L10.312.808a2.169 2.169 0 013.381.001l1.544 1.922a1.154 1.154 0 001.035.428l2.452-.267a2.163 2.163 0 012.386 2.389l-.267 2.452c-.043.397.117.784.429 1.035l1.922 1.544c.451.362.735.878.798 1.453a2.154 2.154 0 01-.798 1.927l-1.922 1.545c-.312.25-.473.637-.429 1.034l.267 2.452a2.166 2.166 0 01-2.387 2.387l-2.452-.267a1.157 1.157 0 00-1.035.429l-1.543 1.92a2.164 2.164 0 01-1.693.809zm-4.138-4.169c.658 0 1.273.295 1.687.809l1.543 1.922a1.152 1.152 0 00.909.437c.357 0 .689-.159.911-.437l1.543-1.92a2.152 2.152 0 011.922-.797l2.452.267a1.07 1.07 0 00.253 0 1.166 1.166 0 001.032-1.285l-.267-2.452a2.156 2.156 0 01.797-1.922l1.921-1.544a1.157 1.157 0 00.431-1.038 1.16 1.16 0 00-.429-.782l-1.922-1.544a2.155 2.155 0 01-.797-1.923l.267-2.451a1.163 1.163 0 00-1.284-1.285l-2.451.266a2.155 2.155 0 01-1.922-.795l-1.545-1.923a1.152 1.152 0 00-.909-.437 1.16 1.16 0 00-.911.437L9.549 3.357a2.156 2.156 0 01-1.924.796l-2.452-.267a1.271 1.271 0 00-.249.001 1.154 1.154 0 00-.784.428 1.155 1.155 0 00-.251.857l.267 2.451a2.158 2.158 0 01-.797 1.923L1.437 11.09a1.162 1.162 0 00-.43 1.038c.034.31.187.588.429.782l1.922 1.543c.58.465.878 1.184.797 1.922l-.267 2.452a1.156 1.156 0 00.429 1.035 1.151 1.151 0 00.857.25l2.452-.267c.079-.009.157-.013.236-.013z"
    })));
    return _this;
  }
  return IconCheckBadge;
}(_Icon3.default);
exports.default = IconCheckBadge;